export default __webpack_public_path__ + "static/media/oc_globe_logo.96e23c9a.svg";